import React, { Component } from 'react'
import cx from 'classnames'
import Popper from 'popper.js'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import { bind } from '../../util/react'
import List from '../list/list'

import style from './button-dropdown.module.css'

const propTypes = {
    activator: PropTypes.node.isRequired,
    appendTo: PropTypes.string,
    children: PropTypes.node.isRequired, // default value is body. ('parent' is another option)
    className: PropTypes.string,
    dropdownClassName: PropTypes.string,
    noPadding: PropTypes.bool,
    placement: PropTypes.string, // `top`, `left`, `bottom`, `right` + optional `end` or `start` variations
    useDefaultModifiers: PropTypes.bool
}

const defaultProps = {
    appendTo: 'body',
    placement: 'bottom-end',
    useDefaultModifiers: true
}

const MODIFIERS_DEFAULT = ['offset', 'preventOverflow', 'arrow', 'flip', 'applyStyle', 'keepTogether', 'shift']

/**
 * ButtonDropdown component.
 * @author Silvio Lehmann
 * @example
 *  <ButtonDropdown placement={'bottom-end'} activator={<Button primary>Download</Button>}>
 *      <Button>PDF (detailed)</Button>
 *      <Button>CSV</Button>
 *  </ButtonDropdown>
 */
export default class ButtonDropdown extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isButtonGroupVisible: false
        }
        this.popper = null
        bind(this)
    }

    UNSAFE_componentWillMount() {
        this.popoverContentNode = document.createElement('div')
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.onDropdown)
        ReactDOM.unmountComponentAtNode(this.popoverContentNode)
    }

    render() {
        const { activator, className, noPadding } = this.props
        const combinedClassName = cx(style['button-dropdown'], className, {
            [style['no-padding']]: noPadding
        })
        return (
            <div className={combinedClassName} onClick={this.onActivatorClick}>
                {activator}
            </div>
        )
    }

    renderPopover(target) {
        if (this.popper !== null) {
            return
        }

        const { appendTo, children, dropdownClassName, placement, useDefaultModifiers } = this.props

        const popperConfig = {
            arrowClassNames: [],
            classNames: [],
            content: this.popoverContentNode,
            contentType: 'node',
            parent: appendTo
        }

        if (appendTo === 'parent') {
            popperConfig.parent = target.parentElement
        }

        const composedDropdownClassName = cx(style['dropdown'], dropdownClassName)

        ReactDOM.render(
            <div className={composedDropdownClassName}>
                <List>{children}</List>
            </div>,
            this.popoverContentNode
        )

        const popperOptions = {
            boundariesPadding: 0,
            gpuAcceleration: false,
            offset: 2,
            placement,
            removeOnDestroy: true
        }

        if (useDefaultModifiers) {
            popperOptions['modifiers'] = MODIFIERS_DEFAULT
        }

        this.popper = new Popper(target, popperConfig, popperOptions)
        this.popper.onCreate(self => self.update())
        document.addEventListener('click', this.onDropdown)
    }

    onActivatorClick(e) {
        if (e.target.className.indexOf === undefined || e.target.className.indexOf('button-dropdown') === -1) {
            this.renderPopover(e.target)
        }
    }

    onDropdown(event) {
        document.removeEventListener('click', this.onDropdown)
        this.destroyPopper()
    }

    destroyPopper() {
        if (!this.popper) {
            return
        }
        this.popper.destroy()
        this.popper = null
    }
}

ButtonDropdown.defaultProps = defaultProps
ButtonDropdown.propTypes = propTypes
